<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      // msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted () {
    if (this._isMobile()) {
      console.log('切换为移动地址')
      // var url = "https://app.sjzeis.com"
      // 读取当前地址
      let currUrl = window.location.href
      // https://www.sjzeis.com/article/details/368
      let url = currUrl.replace('www.', 'app.')
      // window.localtion.href = url
      console.log('当前地址：'+url)
      window.open(url,"_self")
    }
  },
  methods: {
    _isMobile() {
    	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    	 return flag;
    }
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
a, a:hover {
  color: #333333;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.badge-pill {
  color: #808080;
  font-weight: normal;
}
.container {
  /* padding: 0!important; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue